import { BASE_URL, HttpError } from './apiClient';

export interface PortalAuthResponse {
    access_token: string;
    expires_in: number;
    saasSessionToken: string | null;
    tenantCode: string;
    ciu: string;
    companyName: string | null;
    is_token: string | null;
    // App session credentials: the API bearer + its refresh token, renewed via
    // /connect/portal-refresh, decoupled from the host IS JWT's lifetime.
    app_access_token: string;
    app_refresh_token: string;
    app_expires_in: number;
}

export async function exchangePortalNonce(nonce: string): Promise<PortalAuthResponse> {
    const response = await fetch(`${BASE_URL}/connect/portal-auth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nonce }),
    });
    if (!response.ok) {
        throw new HttpError(response.status, `Portal auth failed: ${response.status}`);
    }
    return response.json() as Promise<PortalAuthResponse>;
}
